<template>

    <m-edit1/>

    <m-categories-300 v-bind='{...{"slicer":null},...{}}' :style='""' class="my-5 container" ></m-categories-300>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mCategories300 from '@moeinmdn/miw-alpha-components/src/package/Category/Categories/Categories300';

export default {
    name: 'HomeView',
    components: {mEdit1, mCategories300 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
